export const NotifyMassages = {
  signInSuccess: "You are now successfully logged in",
  resetPasswordSuccess: "Alright! Password successfully updated",
  changePasswordSuccess:
    "Alright! Password successfully updated. You are now logged in with your new password",
};
